import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { errorToast } from "@/shared/utils/helpers";
import { AppsmenError } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

interface Props {
  id: string;
  refundAmount: string;
}

const usePartialRefundSessionMutation = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();
  const partialRefundSessionMutation = useMutation<
    undefined,
    AppsmenError,
    Props
  >({
    mutationFn: ({ id, refundAmount }) =>
      get2(
        `internal/secure/pos/v1/order/sessions/refund${branchId}/${id}/${refundAmount}`
      ),
    onSuccess: () => {
      toast.success(t("success.success"));
    },
    onError: (error) => {
      if (error.response?.status === 503) {
        errorToast(error?.response?.data?.error_message);
      }
    },
  });

  return partialRefundSessionMutation;
};

export default usePartialRefundSessionMutation;
